import React from 'react';
import { injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import { } from 'react-router-dom';
import { compose } from 'redux';
import {
  LayoutWrapperMain,
  Page,
  LiveStreamingInfo,
} from '../../components';
import config from '../../config';
import './livestreaming.global.scss';

interface Props {
  params: any;
  intl: any;
  scrollingDisabled: any;
}

const LiveStreamingComponent: React.FC<Props> = (props: Props) => {
  const { intl, scrollingDisabled, params } = props;
  const { siteTitle } = config;
  const schemaTitle = intl.formatMessage(
    { id: 'LiveManagement.page.title' },
    { siteTitle },
  );
  return (
    <Page
      title={schemaTitle}
      scrollingDisabled={scrollingDisabled}
      schema={{
        '@context': 'http://schema.org',
        '@type': 'WebPage',
        name: schemaTitle,
      }}
    >
      <LayoutWrapperMain className="layoutWrapperMain">
        <div className="content">
          <LiveStreamingInfo id={params.id} />
        </div>
      </LayoutWrapperMain>
    </Page>
  );
};

const mapStateToProps = () => ({
});

const mapDispatchToProps = () => ({
});

const LiveStreamingComponentPage = compose(

  connect(mapStateToProps, mapDispatchToProps),
  injectIntl,
)(LiveStreamingComponent);

export default LiveStreamingComponentPage;
